/**
 * Pojistka na plné úložiště prohlížeče — pro CELOU appku najednou.
 *
 * Tom, 1. 11. 2026: nejdřív „Menu se nepodařilo uložit: Úložiště prohlížeče je plné", pak při přepnutí dne
 * v Poledním menu celá obrazovka „QuotaExceededError: The quota has been exceeded". `localStorage.setItem`
 * při plném úložišti výjimku HÁZÍ — a ta proletí rovnou do vykreslování (zustand `persist` zapisuje
 * synchronně uprostřed `setState`), takže umře celá obrazovka.
 *
 * Pravda je na serveru; prohlížeč drží jen kopii pro rychlý start. Když se kopie nevejde, zápis se vynechá,
 * appka jede z paměti a ze serveru dál. Stará kopie klíče se NEMAŽE (u čistě místních věcí je stará kopie
 * lepší než žádná; synchronizované moduly si ji při startu stejně přepíšou serverovou verzí).
 * Jednou za sezení se to ohlásí (`ohlasPlneUloziste`).
 *
 * Import jako první věc v `main.tsx` — dřív, než se rozjede jakýkoli `persist`.
 */
let ohlasit: (() => void) | null = null;
let ceka = false;

/** `uloziste.ts` sem po načtení dosadí hlášku (bez kruhového importu přes toast-store). */
export function nastavOhlaseniPlna(f: () => void): void { ohlasit = f; }

function jePlno(e: unknown): boolean {
  if (typeof DOMException !== 'undefined' && e instanceof DOMException) {
    return e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.code === 22 || e.code === 1014;
  }
  return false;
}

try {
  if (typeof Storage !== 'undefined') {
    const puvodni = Storage.prototype.setItem;
    Storage.prototype.setItem = function setItemSPojistkou(this: Storage, klic: string, hodnota: string) {
      try {
        puvodni.call(this, klic, hodnota);
      } catch (e) {
        if (!jePlno(e)) throw e;
        console.warn('[uloziste] plno — kopie se neuložila, appka jede z paměti a ze serveru:', klic, `${Math.round(hodnota.length / 1024)} kB`);
        if (!ceka) { ceka = true; setTimeout(() => { ceka = false; ohlasit?.(); }, 0); }
      }
    };
  }
} catch { /* prostředí bez Storage */ }

export {};
